export default Object.freeze({
  Parser: 1,
  Generic: 2,
});
